module.exports = __webpack_public_path__ + "img/check.692ca1d7.png";